var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_14196",
    "data-name": "Group 14196",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2955",
    "data-name": "Rectangle 2955",
    width: 20,
    height: 20,
    fill: "#0d162f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13443",
    "data-name": "Group 13443",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12983",
    "data-name": "Path 12983",
    d: "M18.518,11.852H14.074a1.482,1.482,0,0,0-1.482,1.482v1.481H8.455l-3.27-3.27V7.408H6.666A1.482,1.482,0,0,0,8.148,5.926V1.482A1.481,1.481,0,0,0,6.666,0H2.222A1.482,1.482,0,0,0,.74,1.482V5.926A1.483,1.483,0,0,0,2.222,7.408H3.7v4.137L.217,15.032a.741.741,0,0,0,0,1.047l3.7,3.7a.741.741,0,0,0,1.047,0L8.455,16.3h4.137v1.481a1.483,1.483,0,0,0,1.482,1.482h4.444A1.482,1.482,0,0,0,20,17.778V13.334a1.481,1.481,0,0,0-1.482-1.482M2.222,1.482H6.667V5.927H2.222Zm2.222,16.73L1.788,15.556,4.444,12.9,7.1,15.556Zm9.63-4.878h4.445v4.445H14.074Z",
    transform: "translate(0)",
    fill: "#0d162f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.c7f8e15501f0999abb5ba21efaee1702.svg";
export { ForwardRef as ReactComponent };